<div class="mat-mdc-dialog-content">
  <span class="close-icon" [mat-dialog-close]="">
    <mat-icon>close</mat-icon>
  </span>
  <div class="content">
    <div class="content-header">
      <img src="/assets/images/facebook-connection/set-promo-ads.svg" />
      <div class="content-header-title">
        {{ "partner.edit.startUsingPromoAds" | translate }}
      </div>
    </div>
    <div
      class="content-info"
      [innerHTML]="
        'partner.edit.setupPromoAdsInfo' | withLink: 'url.facebookAds'
      "
    ></div>
    <button
      (click)="checkClaimStatus()"
      [disabled]="loading"
      class="btn btn--grey"
    >
      {{ "partner.edit.setupPromoAdsTitle" | translate }}
    </button>
  </div>
</div>
